import type { IApiError } from './api'

export enum REVIEW_STATUS {
  ANSWERED = 'answered',
  DECIDED_NOT_TO_REPORT = 'decided_not_to_report',
  EDITED = 'edited',
  PENDING_REPORT = 'pending_report',
  PROPOSE_REPORT = 'propose_to_report',
  REMOVED = 'removed',
  REPORTED = 'reported',
  UNTREATED_REPORT = 'untreated_report',
}

export enum ML_LABEL {
  BUG = 'is_bug_report',
  BUSINESS_MODEL = 'is_business_model',
  FEATURE_SUGGESTION = 'is_feature_request',
  NONE = 'is_no_label',
  RATING = 'is_rating',
  TRASH = 'is_trash',
  UX = 'is_user_experience',
}

export interface IMacroApp {
  app_key: string
  device_type: string
}

export interface IReviewTopic {
  applications: IMacroApp[] | null
  category: string
  created_at: number
  created_by: string
  description: string
  id: string
  is_all_apps: boolean
  label: string
  updated_at: number
  updated_by: string
}

export interface IReview {
  app_key: string
  app_version: string
  content: string
  content_en: string
  country_code: string
  created_at: number
  device: string
  device_type: string
  id: string
  language: string
  ml_labels: string[]
  ram_mb: number
  rating: number
  replies: {
    content: string
    content_en: string
    created_at: number
    created_by: string
    id: string
    review_history_id: string
  }[]
  response_openai: string
  response_openai_en: string
  sdk_version: number
  status: REVIEW_STATUS[]
  title: string
  title_en: string
  topics: IReviewTopic[]
  updated_at: number
  username: string
}

export interface IReportReviewMacro {
  applications: IMacroApp[] | null
  content: string
  created_at: number
  created_by: string
  id: string
  is_all_apps: boolean
  keywords: string[]
  reason: string
  subject: string
  updated_at: number
  updated_by: string
}

export interface IReplyReviewMacro {
  applications: IMacroApp[] | null
  automation_keywords: string[]
  content: string
  id: string
  is_all_apps: boolean
  name: string
}

export interface IReviewTopicPayload {
  applications: IMacroApp[]
  category: string
  description: string
  is_all_apps: boolean
  label: string
}

export interface IReviewReplyMacroPayload {
  applications: IMacroApp[]
  content: string
  is_all_apps: boolean
  name: string
}

export interface IReviewReportMacroPayload {
  applications: IMacroApp[]
  content: string
  is_all_apps: boolean
  keywords: string[]
  reason: string
  subject: string
}

export interface IReportReviewsPayload {
  macro?: string
  reason?: string
  review_ids: string[]
  subject?: string
}

export interface IReportReviewsResponse {
  errors: {
    error: IApiError
    index: number
  }[]
  nb_reply_error: number
  nb_reply_success: number
  total: number
}

export interface IReplyToReviewsPayload {
  content: string
  review_ids: string[]
}

export interface IReplyToReviewsResponse {
  errors: {
    error: IApiError
    index: number
  }[]
  nb_reply_error: number
  nb_reply_success: number
  total: number
}
